import { RouteObject, Navigate } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const StudentsPage = lazy(() => import('../pages/students/page'));
const NewStudentPage = lazy(() => import('../pages/students/new/page'));
const StudentDetailPage = lazy(() => import('../pages/students/[id]/page'));
const EditStudentPage = lazy(() => import('../pages/students/[id]/edit/page'));
const UsersPage = lazy(() => import('../pages/users/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/login" replace />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/students',
    element: <StudentsPage />
  },
  {
    path: '/students/new',
    element: <NewStudentPage />
  },
  {
    path: '/students/:id',
    element: <StudentDetailPage />
  },
  {
    path: '/students/:id/edit',
    element: <EditStudentPage />
  },
  {
    path: '/users',
    element: <UsersPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;